<template>
	<div class="grid-flex-container">
		<div class="grid-toolbar pb-0">
			<v-tabs @change="onTabChanged">
				<v-tab v-for="(item, index) in tabs" :key="index">{{
					item.Name
				}}</v-tab>
			</v-tabs>
		</div>
		<div class="generic-grid-container">
			<grid-history-per-record v-if="tab == 0" />
			<grid-history-per-user v-if="tab == 1" />
		</div>
	</div>
</template>

<script>
import GridHistoryPerRecord from './GridHistoryPerRecord.vue';
import GridHistoryPerUser from './GridHistoryPerUser.vue';
export default {
	name: 'GridHistory',
	components: { GridHistoryPerRecord, GridHistoryPerUser },
	data() {
		return {
			tab: 0,
			tabs: [
				{
					Name: 'Per Record',
				},
				{
					Name: 'Per User',
				},
			],
		};
	},
	methods: {
		onTabChanged(e) {
			this.tab = e;
		},
	},
};
</script>
